<template>
  <div id="wx_qr_code"></div>
</template>

<script>
import WeixinConfig from "../../js/weixin.config";

export default {
  name: "WeixinQrCode",

  mounted() {
    this.createQrCodeImage();
  },
  methods: {
    createQrCodeImage() {
      let redirectUri = window.location.href;
      let index = redirectUri.indexOf('www.');
      if (index != -1) {
        let ll = redirectUri.split('www.');
        let newStr = '';
        for (let i = 0; i < ll.length; i++) {
          newStr += ll[i];
        }
        redirectUri = newStr
      }
      redirectUri = encodeURI(redirectUri);
      console.log(redirectUri);
      let obj = new WxLogin({
        self_redirect: false,
        id: "wx_qr_code",
        appid: WeixinConfig.appId,
        scope: 'snsapi_login',
        redirect_uri: redirectUri,
        state: '1001',
        style: 'black',
        href: 'https://shslqxh.com/static/weixinlogin.css'
      });

      let iframe = document.getElementById('wx_qr_code').firstChild;
      iframe.width = '250px';
      iframe.height = '250px';


    },
  }
}
</script>

<style scoped>
  #wx_qr_code {
    border: solid 1px #eeeeee;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/WeixinQrCode.vue